import { basenameForWebApp } from '@ms/yammer-web-support/dist/location';
import { doesBrowserSupportPWA, initializeInstallPrompt, registerServiceWorker } from '@ms/yammer-web-support/dist/pwa';
import 'requestidlecallback';

import { reportErrorWithCode } from './bootstrapTelemetry';

const initializeServiceWorker = () => {
  if (!doesBrowserSupportPWA()) {
    return;
  }

  // Listen to `beforeinstallprompt` event so that we can show a custom install prompt.
  initializeInstallPrompt();

  requestIdleCallback(async () => {
    try {
      const scope = `${basenameForWebApp}/`;
      const path = `${process.env.SERVICE_WORKER}`;
      await registerServiceWorker({ scope, path });
    } catch (error) {
      reportErrorWithCode(error, 'ServiceWorkerRegistrationFailed');
    }
  });
};

export default initializeServiceWorker;
